import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { detailStyle } from "./styles";
import { Grid, Paper, Divider, Button, Typography } from "@material-ui/core";
import Header from "../../../partials/header";
import Loading from "../../loading";
import PriceFormat from "../../../partials/priceFormat";
import GetAppIcon from "@material-ui/icons/GetApp";
import { isJsonString } from "../../../utils/setting";
import ReactHtmlParser from "react-html-parser";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
export class Plugin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plugin: {},
    };
  }
  async componentDidMount() {
    this.props.getPluginCategory();
    const { match } = this.props;
    let pluginKey = match.params.pluginKey;
    this.loading.startLoading();
    let result = await this.props.getOnePlugin({ pluginKey: pluginKey });
    this.loading.stopLoading();
    if (result.code === 1) this.setState({ plugin: result.data });
  }
  async componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.pluginKey !== this.props.match.params.pluginKey
    ) {
      let pluginKey = nextProps.match.params.pluginKey;
      this.loading.startLoading();
      let result = await this.props.getOnePlugin({ pluginKey: pluginKey });
      this.loading.stopLoading();
      if (result.code === 1) this.setState({ plugin: result.data });
    }
  }
  idAddedPlugin = (pluginKey) => {
    // true => added
    const { listPluginsService } = this.props;
    return (
      listPluginsService.findIndex((item) => item.pluginKey === pluginKey) !==
      -1
    );
  };
  getNameCategory = (id) => {
    let { listPluginCategory } = this.props;
    let find = listPluginCategory.find((e) => e.categoryId === id);
    return find ? find.name : {};
  };
  submitAddPlugin = async (plugin) => {
    this.loading.startLoading();
    await this.props.createPluginService({ pluginKey: plugin.key });
    this.loading.stopLoading();
  };
  submitRemovePlugin = async (plugin) => {
    this.loading.startLoading();
    await this.props.removePluginService({ pluginKey: plugin.key });
    this.loading.stopLoading();
  };
  render() {
    const { t, classes, i18n } = this.props;
    let { plugin } = this.state;
    if (isJsonString(plugin.categoryId))
      plugin.categoryId = JSON.parse(plugin.categoryId);
    if (isJsonString(plugin.user)) plugin.user = JSON.parse(plugin.user);
    let isAdded = this.idAddedPlugin(plugin.key);
    return (
      <>
        <Header
          session={t("plugin")}
          // title={t("Power ups")}
          title={plugin.name}
          backIcon={true}
          actionBack={() => this.props.history.push("/pluginCategory")}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.paper}>
          <Grid container spacing={6}>
            <Grid
              item
              xs={12}
              sm={3}
              md={3}
              lg={3}
              style={{ paddingRight: "1rem" }}
            >
              <div className={classes.image}>
                {plugin.icon && (
                  <img
                    className={classes.image}
                    src={plugin.icon}
                    alt="icon plugin"
                  />
                )}
              </div>
              <div className={classes.container}>
                <div
                  className={classes.containerContent}
                  style={{
                    display: "flex",
                    alignContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <p className={classes.shortDescription}>
                    {t("plugin_madeby")} {plugin.user && plugin.user.userName}
                  </p>
                  <div className={classes.download}>
                    <GetAppIcon
                      style={{ marginLeft: "-6px", height: "18px" }}
                    />{" "}
                    {plugin.totalDownload}
                  </div>
                </div>
                <Divider />
                <div className={classes.containerContent}>
                  <Typography className={classes.titleForm}>
                    {t("plugin_category")}
                  </Typography>
                  {plugin.categoryId &&
                    plugin.categoryId.map((e) => {
                      return (
                        <div
                          className={classes.linkCategory}
                          onClick={() =>
                            this.props.history.push(`/pluginCategory/${e}`)
                          }
                        >
                          {this.getNameCategory(e)
                            ? i18n.language === "vn"
                              ? this.getNameCategory(e).vi
                              : this.getNameCategory(e).en
                            : ""}
                        </div>
                      );
                    })}
                </div>
                <Divider />
                <div className={classes.containerContent}>
                  <Typography className={classes.titleForm}>
                    {t("plugin_price")}
                  </Typography>
                  <PriceFormat
                    value={`${plugin.price} ${
                      this.props.currencyCode || "VND"
                    }`}
                  />
                </div>
                <Divider />
                <div className={classes.containerContent}>
                  {plugin.contact && (
                    <a
                      className={classes.contactPolicy}
                      // title={plugin.contact}
                      href={`mailto:${plugin.contact}`}
                    >
                      <MailOutlineIcon className={classes.icon} />
                      {t("plugin_contact_support")}
                    </a>
                  )}
                  {plugin.policy && (
                    <a
                      className={classes.contactPolicy}
                      href={plugin.policy}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ErrorOutlineIcon className={classes.icon} />{" "}
                      {t("plugin_privacy_policy")}
                    </a>
                  )}
                </div>
                <Divider />
                <div className={classes.containerContent}>
                  <Typography className={classes.titleForm}>
                    {t("plugin_short_description")}
                  </Typography>
                  <div className={classes.shortDescription}>
                    {plugin.shortDescription}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={9} md={9} lg={9}>
              <div className={classes.containerTitle}>
                <div className={classes.nameTitle}>{plugin.name}</div>
                {isAdded ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.buttonRemove}
                    size="small"
                    onClick={() => this.submitRemovePlugin(plugin)}
                  >
                    {t("plugin_remove_power_up")}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    size="small"
                    onClick={() => this.submitAddPlugin(plugin)}
                  >
                    {t("plugin_add_power_up")}
                  </Button>
                )}
              </div>
              <div>{ReactHtmlParser(plugin.fullDescription)}</div>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  listPluginCategory: state.pluginCategory.listPluginCategory,
  listPluginsService: state.pluginServices.listPlugins,
});

const mapDispatch = (dispatch) => ({
  getPluginCategory: dispatch.pluginCategory.getPluginCategory,
  getOnePlugin: dispatch.plugin.getOnePlugin,
  createPluginService: dispatch.pluginServices.create,
  removePluginService: dispatch.pluginServices.remove,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(detailStyle, { withTheme: 0 })(Plugin)));
